<template>
  <section class="contactUs d-flex  mt-10 py-10">
    <v-container>
      <v-row class="justify-center align-center">
        <v-col
          cols="10"
          lg="5"
          class="contactUs--content text-center text-lg-left"
        >
          <h3>
            Sigorta terimleri hakkında daha fazla tanıma mı ihtiyacınız var?
          </h3>
          <p>
            En kapsamlı sigorta sözlüğüne abone olun ve binlerce tanıma ve
            gelişmiş aramaya reklamsız ulaşın!
          </p>
        </v-col>
        <v-col cols="12" sm="8" md="10" lg="6" xl="7" class="mt-10 mt-md-0">
          <form class="contactUs--form ">
            <div>
              <input type="text" placeholder="E-Mail adresinizi yazınız" />
            </div>
            <!-- Hide on mobile button -->
            <v-btn class="contactUs--form--submit d-none d-md-block"
              >Abone Ol</v-btn
            >
            <!-- Hide on mobile button -->
          </form>
        </v-col>
      </v-row>
      <v-container class="text-center">
        <!-- Only shown in mobile button -->
        <v-btn x-large rounded color="success" class="mobile-btn mt-5 d-md-none"
          >Gönder</v-btn
        >
        <!-- Only shown in mobile button -->
      </v-container>
    </v-container>
  </section>
</template>

<script>
export default {}
</script>

<style></style>
